import { createAction, props } from '@ngrx/store';
import { INotificationTypesResponse } from '../models/notification-types.model';

export const loadNotificationTypes = createAction('[NotificationType] Load NotificationTypes');

export const loadNotificationTypesSuccess = createAction(
  '[NotificationType] Load NotificationTypes Success',
  props<{ response: INotificationTypesResponse[] }>()
);

export const loadNotificationTypesFailure = createAction(
  '[NotificationType] Load NotificationTypes Failure',
  props<{ error: Error | any }>()
);
